import type { ValueOf } from '../types';

export const APPLICATIONS = {
  ANALYTICS: 'ANALYTICS',
  ACCOUNT_SETTING: 'ACCOUNT_SETTING',
  SWITCH_LS: 'SWITCH_LS',
  PROFILE: 'PROFILE',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  AUTOMATION_RULES: 'AUTOMATION_RULES',
  AUTOMATION_SUITE: 'AUTOMATION_SUITE',
  PROFILE_MANAGEMENT: 'PROFILE_MANAGEMENT',
  MANAGE_TAGS: 'MANAGE_TAGS',
  MANAGE_CERTIFICATES: 'MANAGE_CERTIFICATES',
  HELP_CENTER: 'HELP_CENTER',
  LEARNERS_URL: 'USER_DIRECTORY',
  ADMIN_DASHBOARD: 'ADMIN_DASHBOARD',
  OVERVIEW_PAGES: 'OVERVIEW_PAGES',
  REVIEWS: 'REVIEWS',
  GLOBAL_REDIRECT: 'GLOBAL_REDIRECT',
  NO_ACTIVE_LEARNING_SITE: 'NO_ACTIVE_LEARNING_SITE',
  VIEW_TEMPLATE: 'VIEW_TEMPLATE',
  ACCREDITATION: 'ACCREDITATION',
  GLOBAL_SEARCH: 'GLOBAL_SEARCH',
  GLOBAL_ASSET_SEARCH: 'GLOBAL_ASSET_SEARCH',
  REINFORCEMENT: 'REINFORCEMENT',
  LOGIN: 'LOGIN',
  ASSET: 'ASSET',
  DSR: 'DSR',
  TESTING: 'TESTING',
  EDIT_READINESS_DASHBOARD: 'EDIT_READINESS_DASHBOARD',
  LEARNER_READINESS_DASHBOARD: 'LEARNER_READINESS_DASHBOARD',
  LEARNER_READINESS_WIDGET: 'LEARNER_READINESS_WIDGET',
  LEARNER_READINESS_PROGRAMS: 'LEARNER_READINESS_PROGRAMS',
  LEARNER_READINESS_NOTIFICATIONS: 'LEARNER_READINESS_NOTIFICATIONS',
  LEARNER_CALL_AI_BOOSTUP: 'LEARNER_CALL_AI_BOOSTUP',
  LEARNER_CALL_AI: 'LEARNER_CALL_AI',
  CALL_AI: 'CALL_AI',
  SINGLETON_CALL_AI: 'SINGLETON_CALL_AI',
  LEARNER_DSR: 'LEARNER_DSR',
  CONTENT_CENTER: 'CONTENT_CENTER',
  EMAIL_LOGS: 'EMAIL_LOGS',
  AUDIT_LOGS: 'AUDIT_LOGS',
  RESTRICTION_PAGES: 'RESTRICTION_PAGES',
  PROGRAM_TEMPLATES: 'PROGRAM_TEMPLATES',
  USER_DETAILS: 'USER_DETAILS',
  GROUP_DETAILS: 'GROUP_DETAILS',
  MISSION_DASHBOARD: 'MISSION_DASHBOARD',
  LEARNER_LEGACY_URL: 'LEARNER_LEGACY_URL',
  COACHING_DASHBOARD: 'COACHING_DASHBOARD',
  ADMIN_PAGES: 'ADMIN_PAGES',
  ADAPTIVE_PAGES: 'ADAPTIVE_PAGES',
  LEARNER_PROFILE: 'LEARNER_PROFILE',
  REVQ: 'REVQ',
  LEARNER_TAG_PROGRAMS: 'LEARNER_TAG_PROGRAMS',
  CALLAI_ADMIN: 'CALLAI_ADMIN',
  MODULE_LIBRARY: 'MODULE_LIBRARY',
  FILES: 'FILES',
  LEARNER_STANDALONE_PAGES: 'LEARNER_STANDALONE_PAGES',
  LEARNER_PEERS: 'LEARNER_PEERS',
  GLOBAL_SEARCH_UI: 'GLOBAL_SEARCH_UI',
  DOC_PLAYER_PREVIEW: 'DOC_PLAYER_PREVIEW',
  TASKS: 'TASKS',
  CONTENT_MEDIA_VOSS: 'CONTENT_MEDIA_VOSS',
  LAPPS_SHARED: 'LAPPS_SHARED',
  COMMAND_CENTER: 'COMMAND_CENTER',
  COURSE_LEARNER: 'COURSE_LEARNER',
  QU_LEARNER: 'QU_LEARNER',
  ACCOUNT_SETTINGS_INTEGRATIONS: 'ACCOUNT_SETTINGS_INTEGRATIONS',
  MICO: 'MICO',
  ACCOUNT_SETTINGS_NEW: 'ACCOUNT_SETTINGS_NEW',
  CHECKLIST: 'CHECKLIST',
  QUEST_ADMIN: 'QUEST_ADMIN',
  QUEST_LEARNER: 'QUEST_LEARNER',
  LEARNER_SESSIONS: 'LEARNER_SESSIONS',
  AI_TUTOR: 'AI_TUTOR',
  AI_TUTORS_LIST: 'AI_TUTORS_LIST',
  PROPERTY_MANAGEMENT_UI: 'PROPERTY_MANAGEMENT_UI',
} as const;

export const APPLICATIONS_LINK_MAP = {
  [APPLICATIONS.LOGIN]: { url: 'login' },
  [APPLICATIONS.ANALYTICS]: { url: 'new/ui/analytics' },
  [APPLICATIONS.GLOBAL_SEARCH]: { url: 'search' },
  [APPLICATIONS.GLOBAL_ASSET_SEARCH]: { url: 'new/ui/assets/search' },
  [APPLICATIONS.NO_ACTIVE_LEARNING_SITE]: { url: 'no_active_ls' },
  [APPLICATIONS.GLOBAL_REDIRECT]: { url: 'redirect' },
  [APPLICATIONS.ACCOUNT_SETTING]: { url: 'account_settings' },
  [APPLICATIONS.SWITCH_LS]: { url: 'choose' },
  [APPLICATIONS.PROFILE]: { url: 'new/ui/admin/my-profile' },
  [APPLICATIONS.AUTOMATION_RULES]: { url: 'ui/rules' },
  [APPLICATIONS.AUTOMATION_SUITE]: { url: 'new/ui/admin/automation-suite' },
  [APPLICATIONS.PROFILE_MANAGEMENT]: { url: 'new/ui/admin/profile-management' },
  [APPLICATIONS.TESTING]: { url: 'new/ui/testing' },
  [APPLICATIONS.MANAGE_TAGS]: { url: 'new/ui/tags/manage' },
  [APPLICATIONS.MANAGE_CERTIFICATES]: { url: 'new/ui/manage-certificates' },
  [APPLICATIONS.HELP_CENTER]: { url: 'helpdesk/login' },
  [APPLICATIONS.ANNOUNCEMENT]: { url: 'announcement' },
  [APPLICATIONS.LEARNERS_URL]: { url: 'new/ui/admin/users' },
  [APPLICATIONS.ADMIN_DASHBOARD]: { url: 'new/ui/admin' },
  [APPLICATIONS.OVERVIEW_PAGES]: { url: 'new/ui/overview' },
  [APPLICATIONS.PROGRAM_TEMPLATES]: { url: 'new/ui/admin/templates' },
  [APPLICATIONS.REVIEWS]: { url: 'ui/coaching/dashboard' },
  [APPLICATIONS.ACCREDITATION]: { url: 'ui/accreditation' },
  [APPLICATIONS.REINFORCEMENT]: { url: 'ui/reinforcement' },
  [APPLICATIONS.VIEW_TEMPLATE]: { url: 'edit-mail-template?templateId=' },
  [APPLICATIONS.ASSET]: { url: `new/ui/assets` },
  [APPLICATIONS.DSR]: { url: `new/ui/dsr` },
  [APPLICATIONS.EDIT_READINESS_DASHBOARD]: { url: 'new/ui/dashboards' },
  [APPLICATIONS.LEARNER_READINESS_DASHBOARD]: { url: 'new/ui/learner/home' },
  [APPLICATIONS.LEARNER_STANDALONE_PAGES]: { url: 'new/ui/learner/page' },
  [APPLICATIONS.LEARNER_READINESS_WIDGET]: { url: 'new/ui/learner/widget' },
  [APPLICATIONS.LEARNER_READINESS_PROGRAMS]: { url: 'new/ui/learner/programs' },
  [APPLICATIONS.LEARNER_READINESS_NOTIFICATIONS]: { url: 'new/ui/learner/notifications' },
  [APPLICATIONS.LEARNER_CALL_AI_BOOSTUP]: { url: 'new/ui/learner/integrations/boostup' },
  [APPLICATIONS.LEARNER_CALL_AI]: { url: 'new/ui/learner/callai' },
  [APPLICATIONS.CALL_AI]: { url: 'new/ui/callai' },
  [APPLICATIONS.SINGLETON_CALL_AI]: { url: 'new/ui/singleton-callai' },
  [APPLICATIONS.LEARNER_DSR]: { url: 'new/ui/learner/dsr' },
  [APPLICATIONS.LEARNER_LEGACY_URL]: { url: 'new/ui/learner' },
  [APPLICATIONS.CONTENT_CENTER]: { url: 'new/ui/content-center' },
  [APPLICATIONS.EMAIL_LOGS]: { url: 'new/ui/system-logs/email' },
  [APPLICATIONS.AUDIT_LOGS]: { url: 'new/ui/system-logs/audit' },
  [APPLICATIONS.RESTRICTION_PAGES]: { url: 'new/ui/restrictions' },
  [APPLICATIONS.USER_DETAILS]: { url: 'new/ui/admin/user' },
  [APPLICATIONS.GROUP_DETAILS]: { url: 'new/ui/admin/group' },
  [APPLICATIONS.MISSION_DASHBOARD]: { url: 'new/ui/learner/mission-dashboard' },
  [APPLICATIONS.COACHING_DASHBOARD]: { url: 'new/ui/learner/coaching-dashboard' },
  [APPLICATIONS.ADMIN_PAGES]: { url: 'new/ui/pages' },
  [APPLICATIONS.ADAPTIVE_PAGES]: { url: 'new/ui/pages/adaptive' },
  [APPLICATIONS.LEARNER_PROFILE]: { url: 'new/ui/learner/my-profile' },
  [APPLICATIONS.LEARNER_PEERS]: { url: 'new/ui/learner/participants' },
  [APPLICATIONS.REVQ]: { url: 'new/ui/revq' },
  [APPLICATIONS.LEARNER_TAG_PROGRAMS]: { url: 'new/ui/learner/tag/programs' },
  [APPLICATIONS.CALLAI_ADMIN]: { url: 'new/ui/admin/callai/admin' },
  [APPLICATIONS.MODULE_LIBRARY]: { url: 'new/ui/learner/module-library' },
  [APPLICATIONS.GLOBAL_SEARCH_UI]: { url: 'new/ui/global_search' },
  [APPLICATIONS.DOC_PLAYER_PREVIEW]: { url: 'new/ui/doc-player-preview' },
  [APPLICATIONS.TASKS]: { url: 'new/ui/learner/training/tasks' },
  [APPLICATIONS.CONTENT_MEDIA_VOSS]: { url: 'new/ui/voss' },
  [APPLICATIONS.LAPPS_SHARED]: { url: 'new/ui/details' },
  [APPLICATIONS.COMMAND_CENTER]: { url: 'new/ui/learner/home/command-center' },
  [APPLICATIONS.COURSE_LEARNER]: { url: 'new/ui/learner/course' },
  [APPLICATIONS.QU_LEARNER]: { url: 'new/ui/learner/update' },
  [APPLICATIONS.ACCOUNT_SETTINGS_INTEGRATIONS]: { url: 'new/ui/account-settings/integrations' },
  [APPLICATIONS.MICO]: { url: 'new/ui/coaching' },
  [APPLICATIONS.QUEST_ADMIN]: { url: 'new/ui/reinforcement/admin' },
  [APPLICATIONS.QUEST_LEARNER]: { url: 'new/ui/reinforcement/learner' },
  [APPLICATIONS.ACCOUNT_SETTINGS_NEW]: { url: 'new/ui/account-settings' },
  [APPLICATIONS.CHECKLIST]: { url: 'new/ui/checklist' },
  [APPLICATIONS.LEARNER_SESSIONS]: { url: 'new/ui/learner/sessions-ilt' },
  [APPLICATIONS.AI_TUTOR]: { url: 'new/ui/learner/tutorial' },
  [APPLICATIONS.AI_TUTORS_LIST]: { url: 'new/ui/learner/training/tutorials' },
  [APPLICATIONS.PROPERTY_MANAGEMENT_UI]: { url: 'new/ui/account-settings/custom-properties' },
};

export const APPLICATIONS_LINK_MAP_V2 = {
  ...APPLICATIONS_LINK_MAP,
  [APPLICATIONS.PROFILE_MANAGEMENT]: { url: 'new/ui/users/profile-management' },
  [APPLICATIONS.LEARNERS_URL]: { url: 'new/ui/users' },
  [APPLICATIONS.ADMIN_DASHBOARD]: { url: 'new/ui/training' },
  [APPLICATIONS.MANAGE_TAGS]: { url: 'new/ui/training/tags/manage' },
  [APPLICATIONS.MANAGE_CERTIFICATES]: { url: 'new/ui/training/manage-certificates' },
  [APPLICATIONS.MISSION_DASHBOARD]: { url: 'new/ui/learner/review/mission-dashboard' },
  [APPLICATIONS.COACHING_DASHBOARD]: { url: 'new/ui/learner/review/coaching-dashboard' },
  [APPLICATIONS.LEARNER_READINESS_PROGRAMS]: { url: 'new/ui/learner/training/programs' },
  [APPLICATIONS.MODULE_LIBRARY]: { url: 'new/ui/learner/training/modules' },
  [APPLICATIONS.FILES]: { url: 'new/ui/learner/training/files' },
  [APPLICATIONS.LEARNER_PEERS]: { url: 'new/ui/learner/training/participants' },
  [APPLICATIONS.TASKS]: { url: 'new/ui/learner/training/tasks/sme' },
  [APPLICATIONS.AUDIT_LOGS]: { url: 'new/ui/account-settings/system-logs/audit' },
  [APPLICATIONS.EMAIL_LOGS]: { url: 'new/ui/account-settings/system-logs/email' },
};

export default function getApplicationAccessLink(
  type: ValueOf<typeof APPLICATIONS>,
  options?: { hash: string }
) {
  if (options?.hash) {
    return `/${APPLICATIONS_LINK_MAP_V2[type]?.url}${options.hash}`;
  }
  return `/${APPLICATIONS_LINK_MAP_V2[type]?.url}`;
}
